(() => {
  const API='https://late-nite-daily-backend.vercel.app';
  const validUuid = value => /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(value || ''));
  const tierForKey = key => ({talent_skip:'skip',talent_featured:'featured',talent_headliner:'headliner'})[key] || '';
  const json=async(res)=>{const data=await res.json().catch(()=>({}));if(!res.ok)throw new Error(data.description||data.message||data.error||`HTTP ${res.status}`);return data;};
  const addHidden=(form,name,value)=>{let el=form.querySelector(`input[name="${name}"]`);if(!el){el=document.createElement('input');el.type='hidden';el.name=name;form.appendChild(el);}el.value=String(value??'');return el;};

  document.querySelectorAll('.lrnd-product-form').forEach(form=>{
    const button=form.querySelector('[data-lrnd-product-checkout]');
    const status=form.querySelector('[data-lrnd-product-error]');
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      if(button?.disabled)return;
      const original=button?.textContent||'CONTINUE TO CHECKOUT';
      if(button){button.disabled=true;button.textContent='CONNECTING CHECKOUT…';}
      if(status)status.textContent='';
      try{
        const baseFd=new FormData(form);
        const submissionId=String(baseFd.get('properties[_talent_submission_id]')||'');
        const productKey=String(baseFd.get('properties[_lrnd_product_key]')||'');
        const tier=tierForKey(productKey);
        const passToken=String(baseFd.get('properties[_artist_pass_token]')||localStorage.getItem('lrndTalentArtistPassToken')||'');
        const returnPath=String(baseFd.get('properties[_lrnd_return_path]')||(passToken?`/pages/talent-patrol?artist_pass=${encodeURIComponent(passToken)}`:'/pages/talent-patrol'));
        const isTalent=productKey.startsWith('talent_');
        const isLate=productKey.startsWith('late_');
        let datePassToken='';
        if(isLate){
          try{datePassToken=new URLSearchParams(location.search).get('date_pass')||localStorage.getItem('lrndDateNightPassToken')||'';}catch(_){datePassToken='';}
          const ensured=await json(await fetch(`${API}/api/date-night-pass`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'ensure',token:datePassToken})}));
          datePassToken=String(ensured.passToken||'');if(!validUuid(datePassToken))throw new Error('Could not create your Date Night Pass.');
          try{localStorage.setItem('lrndDateNightPassToken',datePassToken);}catch(_){}
          addHidden(form,'properties[_date_night_pass_token]',datePassToken);
          addHidden(form,'properties[_lrnd_return_path]',`/pages/late-nite-date-night?date_pass=${encodeURIComponent(datePassToken)}`);
        }
        if(isTalent && (!validUuid(submissionId)||!tier||!passToken))throw new Error('This checkout is not connected to a valid Artist Pass song. Return to your Artist Pass and choose the tier again.');

        if(isTalent||isLate){
          // Dedicated one-item cart means Shopify's cart_token points to exactly one Talent Patrol purchase intent.
          await json(await fetch('/cart/clear.js',{method:'POST',headers:{Accept:'application/json'}}));
        }

        const fd=new FormData(form);
        const add=await json(await fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}}));

        if(isTalent){
          const cart=await json(await fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'}));
          const cartToken=String(cart.token||'').split('?')[0];
          if(!cartToken)throw new Error('Shopify did not return a cart token. Checkout was stopped before payment so the song cannot become detached.');

          const intent=await json(await fetch(`${API}/api/commerce-intent`,{
            method:'POST',headers:{'Content-Type':'application/json'},
            body:JSON.stringify({submissionId,passToken,cartToken,tier,productKey})
          }));
          const checkoutRef=String(intent.checkoutRef||'');
          if(!checkoutRef)throw new Error('The Talent Patrol checkout could not be bound to this song.');

          const attrs={
            _lrnd_product_key:productKey,
            _lrnd_talent_submission_id:submissionId,
            _talent_submission_id:submissionId,
            _lrnd_artist_pass_token:passToken,
            _artist_pass_token:passToken,
            _lrnd_checkout_ref:checkoutRef,
            _lrnd_return_path:returnPath
          };
          await json(await fetch('/cart/update.js',{
            method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({attributes:attrs,note:`LRND:${checkoutRef}`})
          }));

          try{
            localStorage.setItem('lrndTalentArtistPassToken',passToken);
            localStorage.setItem('lrndTalentSubmissionId',submissionId);
            localStorage.setItem('lrndTalentCheckoutPending',JSON.stringify({submissionId,passToken,productKey,tier,cartToken,checkoutRef,returnPath,createdAt:Date.now()}));
          }catch(_){ }
        }
        if(isLate){
          const returnPath=`/pages/late-nite-date-night?date_pass=${encodeURIComponent(datePassToken)}`;
          const attrs={_lrnd_product_key:productKey,_lrnd_date_night_pass_token:datePassToken,_date_night_pass_token:datePassToken,_lrnd_return_path:returnPath};
          await json(await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:attrs})}));
          try{localStorage.setItem('lrndDateNightCheckoutPending',JSON.stringify({passToken:datePassToken,productKey,returnPath,createdAt:Date.now()}));}catch(_){}
        }
        location.href='/checkout';
      }catch(err){
        console.error('Lindsey Live checkout bind failed',err);
        if(status)status.textContent=err.message||'Could not start checkout.';
        if(button){button.disabled=false;button.textContent=original;}
      }
    });
  });
})();
